// extracted by mini-css-extract-plugin
export default {"deletedItemFilterWrapper":"_649c0211513d4aec","togglerWrapper":"c40719374bac7d74","titleWrapper":"_250f8e8357dead98"};